module.exports = __webpack_public_path__ + "static/media/cammino_santiago_2.06c59921.jpg";